export default {total:'Total',subtotal:'Subtotal',quarter:'Q{{q}}'};